'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData from "./app.data.-App-Document-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentData$CreditNote$() {
}
export { $c_Lapp_data_AppDocumentData$CreditNote$ as $c_Lapp_data_AppDocumentData$CreditNote$ };
$p = $c_Lapp_data_AppDocumentData$CreditNote$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentData$CreditNote$;
/** @constructor */
function $h_Lapp_data_AppDocumentData$CreditNote$() {
}
export { $h_Lapp_data_AppDocumentData$CreditNote$ as $h_Lapp_data_AppDocumentData$CreditNote$ };
$h_Lapp_data_AppDocumentData$CreditNote$.prototype = $p;
$p.n = (function() {
  return "CreditNote";
});
$p.bK7 = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData.$c_Lapp_data_AppDocumentData$CreditNote(x$0.e(0));
});
$p.U = (function(p) {
  return this.bK7(p);
});
var $d_Lapp_data_AppDocumentData$CreditNote$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentData$CreditNote$, "app.data.AppDocumentData$CreditNote$", ({
  zM: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentData$CreditNote$ as $d_Lapp_data_AppDocumentData$CreditNote$ };
var $n_Lapp_data_AppDocumentData$CreditNote$;
function $m_Lapp_data_AppDocumentData$CreditNote$() {
  if ((!$n_Lapp_data_AppDocumentData$CreditNote$)) {
    $n_Lapp_data_AppDocumentData$CreditNote$ = new $c_Lapp_data_AppDocumentData$CreditNote$();
  }
  return $n_Lapp_data_AppDocumentData$CreditNote$;
}
export { $m_Lapp_data_AppDocumentData$CreditNote$ as $m_Lapp_data_AppDocumentData$CreditNote$ };
//# sourceMappingURL=app.data.-App-Document-Data$-Credit-Note$.js.map
